import { render, staticRenderFns } from "./OverviewGeotag.vue?vue&type=template&id=6bb56c04"
import script from "./OverviewGeotag.vue?vue&type=script&lang=js"
export * from "./OverviewGeotag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports